import { d as e } from "../internals/define-built-in.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { t as a } from "../internals/to-string.js";
import { v as r } from "../internals/validate-arguments-length.js";
var n = URLSearchParams,
  i = n.prototype,
  s = t(i.append),
  o = t(i.delete),
  l = t(i.forEach),
  f = t([].push),
  u = new n("a=1&a=2");
u.delete("a", 1), u + "" != "a=2" && e(i, "delete", function (e) {
  var t,
    n = arguments.length,
    i = n < 2 ? void 0 : arguments[1];
  if (n && void 0 === i) return o(this, e);
  var u = [];
  l(this, function (e, t) {
    f(u, {
      key: t,
      value: e
    });
  }), r(n, 1);
  for (var h = a(e), m = a(i), v = 0, d = 0, p = !1, y = u.length; v < y;) t = u[v++], p || t.key === h ? (p = !0, o(this, t.key)) : d++;
  for (; d < y;) (t = u[d++]).key === h && t.value === m || s(this, t.key, t.value);
}, {
  enumerable: !0,
  unsafe: !0
});